<template>
    <app-errors error-title="Page Not Found!">
        <img slot="error-image" src="../assets/errors/page-not-found.png" alt="" />
    </app-errors>
</template>

<script>
import AppErrors from '../components/app-errors/AppErrors.vue';
export default {
    components: { AppErrors },
};
</script>
